import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Label } from '@fabric-app/ui/components/Label';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Checkbox } from '@fabric-app/ui/components/Checkbox/Checkbox';
import React__default from 'react';
import { styled } from 'styled-components';
import CreateOrRenameTagModal from './CreateOrRenameTagModal.js';
import { useMutationTagDelete } from '../mutations/useMutationTagDelete.js';
import { IconShock } from '@fabric-app/icons/old';
import { Link } from '@fabric-app/compat';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { P } from '@fabric-app/ui/components/Typography';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { IconPencil, IconTrash } from '@fabric-app/icons/svg';

const StyledCheckbox = styled(Checkbox.Default).withConfig({
  displayName: "TagItem__StyledCheckbox",
  componentId: "sc-400dc1b4-0"
})([
  `transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-duration:0.2s;transition-timing-function:ease-in-out;&[aria-checked='false']{background:`,
  `;border-color:`,
  `;}`
], cssVar["color-bg-primary"], cssVar["color-border-secondary"]);
const TagListItemWrapper = styled(Flex).attrs({
  gap: "elementsContainer",
  alignItems: "center"
}).withConfig({
  displayName: "TagItem__TagListItemWrapper",
  componentId: "sc-400dc1b4-1"
})([
  `position:relative;height:3.375rem;padding:0 1rem;cursor:pointer;transition:background-color 0.2s ease-in-out;background-color:`,
  `;`,
  `{&:hover{background-color:`,
  `;cursor:pointer;`,
  `[aria-checked='false']{border-color:`,
  `;background:`,
  `;}}}&:not(:last-child){border-bottom:1px solid `,
  `;}`
], cssVar["color-bg-primary"], mediaHover, cssVar["color-bg-tertiary"], StyledCheckbox, cssVar["color-app-primary"], cssVar["color-bg-secondary"], cssVar["color-border-primary"]);
const OverlappingLink = styled(Link).withConfig({
  displayName: "TagItem__OverlappingLink",
  componentId: "sc-400dc1b4-2"
})([
  `position:absolute;inset:0;`
]);
const StyledLabel = styled(Label).withConfig({
  displayName: "TagItem__StyledLabel",
  componentId: "sc-400dc1b4-3"
})([
  `position:absolute;inset:0;cursor:pointer;`
]);
const TagItem = ({ tag, onSelect }) => {
  return /* @__PURE__ */ jsxs(TagListItemWrapper, {
    children: [
      Boolean(!onSelect && !tag.checked) && /* @__PURE__ */ jsx(OverlappingLink, {
        href: `/tags/${tag.id}`
      }),
      /* @__PURE__ */ jsxs(TagItemContent, {
        children: [
          (onSelect || tag.checked !== void 0) && /* @__PURE__ */ jsxs(Fragment, {
            children: [
              /* @__PURE__ */ jsx(StyledCheckbox, {
                id: `tag-${tag.id}-select`,
                name: `tag-${tag.id}-select`,
                "aria-label": `Select tag ${tag.name}`,
                checked: tag.checked,
                onCheckedChange: () => {
                  onSelect?.(tag, !tag.checked ? true : false);
                }
              }),
              /* @__PURE__ */ jsx(StyledLabel, {
                htmlFor: `tag-${tag.id}-select`,
                children: /* @__PURE__ */ jsxs("span", {
                  className: "sr-only",
                  children: [
                    "Select tag ",
                    tag.name
                  ]
                })
              })
            ]
          }),
          /* @__PURE__ */ jsx(TagItemName, {
            children: tag.name
          })
        ]
      }),
      tag.suggested && /* @__PURE__ */ jsx(IconShock, {
        style: {
          color: cssVar["color-text-quaternary"]
        }
      }),
      /* @__PURE__ */ jsx(TagItemDropdown, {
        tag
      })
    ]
  });
};
const TagItemContent = styled.div.withConfig({
  displayName: "TagItem__TagItemContent",
  componentId: "sc-400dc1b4-4"
})([
  `display:flex;flex-grow:1;gap:10px;align-items:center;`
]);
const TagItemDropdown = ({ tag }) => {
  const deleteTagMutation = useMutationTagDelete();
  const [renameOpen, setRenameOpen] = React__default.useState(false);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(CreateOrRenameTagModal, {
        tag,
        open: renameOpen,
        setOpen: setRenameOpen,
        noTrigger: true
      }),
      /* @__PURE__ */ jsxs(DropdownMenu, {
        renderTriggerElement: ({ onOpenChange }) => /* @__PURE__ */ jsx(DropdownMenu.TriggerButtonThreeDotsSlim, {
          onOpenChange
        }),
        children: [
          /* @__PURE__ */ jsx(DropdownMenu.Group, {
            children: /* @__PURE__ */ jsx(DropdownMenu.Item, {
              iconElement: /* @__PURE__ */ jsx(IconPencil, {}),
              onClick: () => setRenameOpen(true),
              children: "Edit name"
            })
          }),
          /* @__PURE__ */ jsx(DropdownMenu.Group, {
            children: /* @__PURE__ */ jsx(DropdownMenu.Item, {
              variant: "danger",
              iconElement: /* @__PURE__ */ jsx(IconTrash, {}),
              onClick: () => {
                deleteTagMutation.confirmAndMutate(tag.id);
              },
              children: "Delete"
            })
          })
        ]
      })
    ]
  });
};
const TagItemName = styled(P).attrs((props) => {
  return {
    color: "secondary",
    ...props
  };
}).withConfig({
  displayName: "TagItem__TagItemName",
  componentId: "sc-400dc1b4-5"
})([
  ``
]);

export { TagItem as default };
//# sourceMappingURL=TagItem.js.map
